import types from './actionTypes';

const initialState = {
  loading: false,
  aiAgents: [],
  error: '',
};

const aiAgentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_AI_AGENT_STATE:
      return { ...initialState };

    case types.SYNC_AI_AGENTS.REQUEST:
    case types.CREATE_AI_AGENT.REQUEST:
    case types.UPDATE_AI_AGENT.REQUEST:
      return { ...state, loading: true, error: '' };

    case types.SYNC_AI_AGENTS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        aiAgents: [...action.aiAgents],
      };

    case types.CREATE_AI_AGENT.SUCCESS:
    case types.UPDATE_AI_AGENT.SUCCESS:
      return { ...state, loading: false, error: '' };

    case types.SYNC_AI_AGENTS.FAILURE:
    case types.CREATE_AI_AGENT.FAILURE:
    case types.UPDATE_AI_AGENT.FAILURE:
      return { ...state, loading: false, error: action.error.message };

    default:
      return state;
  }
};

export default aiAgentReducer;
